app.service("AcquiredService", ['$rootScope', '$http', function ($rootScope, $http) {

    const service = this;

    const siteHelper = $rootScope.site_helper;

    const modelConstructor = $rootScope.model_constructor;
    let didLogOut = false;

    this.BasicAcquiredModel = modelConstructor.extend(modelConstructor.BasicModel, {

        is_acquired_model: true,

        request_range_id: null,
        site_range_id: null,

        api_code: null,
        is_single_item_model: false,
        request_endpoint: null,

        last_request_did_fail: false,
        request_in_progress: false,
        has_a_completed_request: false,

        requestCallbacks: [],

        dataResponseHandler: null,
        dataSortHandler: null,
        applyItemHandler: null,
        onItemsBuiltHandler: null,

        apiRequire: function (callback) {
            if (this.root.has_a_completed_request) {
                if (callback) {
                    callback();
                }
                return;
            }
            if (this.root.last_request_did_fail) {
                return;
            }
            this.root.apiRequest(callback);
        },

        apiRequest: apiRequest,
        onRequestComplete: onRequestComplete,
        applyBasicObjectDetails: applyBasicObjectDetails,
        buildAcquiredChoices: buildAcquiredChoices,
        applyAcquiredChoice: applyAcquiredChoice,
        birthChoice: function (values) {
            return new service.AcquiredChoice(values);
        }
    });

    this.AcquiredChoice = modelConstructor.extend(modelConstructor.ModelChoice, {

        collectImageParams: function () {
            return {};
        },
        getImgSrc: function (params) {
            const imgSrc = this.super();
            if (imgSrc) {
                return imgSrc;
            }
            const mergedParams = siteHelper.simpleCloneObject(params, this.root.collectImageParams());
            return $rootScope.service.image.determineImgSrc(mergedParams);
        },
        cloneClass: function () {
            return service.AcquiredChoice;
        }
    });

    function apiRequest(callback) {
        const model = this.root;
        if (callback) {
            model.requestCallbacks.push(callback);
        }
        if (model.request_in_progress) {
            return
        }
        model.request_in_progress = true;

        const endpoint = model.request_endpoint;

        if (!endpoint) {
            model.onRequestComplete(null);
            return;
        }


        $http.get(endpoint, {cache: true}).success(function (data, status, headers, config) {
            if (didLogOut) {
                return;
            }
            //console.log("data")
            //console.log(data)

            if (data.redirectlogin) {
                didLogOut = true;
                window.location = "/logout.php?login=1"
                return;
            }

            if (model.dataResponseHandler) {
                data = model.dataResponseHandler(data);
            }

            const acquiredObjects = normalizeAcquiredObjects(model, data);

            saveSourceObjects(acquiredObjects);
            //testPrint(endpoint, acquiredObjects, false);

            model.onRequestComplete(acquiredObjects);

        }).error(function (data, status, headers, config) {
            if (didLogOut) {
                return;
            }
            if (status === 401) {
                didLogOut = true;
                $rootScope.model.account.is_login_required = true;
                window.location.reload();
                return;
            }
            // log error
            model.onRequestComplete(null);
        });

    }

    function saveSourceObjects(acquiredObjects) {
        for (let choiceID in acquiredObjects) {
            const acquiredObject = acquiredObjects[choiceID];
            acquiredObject.source_object = JSON.parse(JSON.stringify(acquiredObject));
        }
    }

    function testPrint(endpoint, acquiredObjects, byTag) {
        console.log(endpoint)
        if (!byTag) {
            console.log(JSON.parse(JSON.stringify(acquiredObjects)))
            return;
        }
        let tag;
        const tagged = {};
        for (let choiceID in acquiredObjects) {
            const acquiredObject = acquiredObjects[choiceID];
            if (!acquiredObject.tags || acquiredObject.tags.length === 0) {
                tag = "untagged";
                if (!tagged[tag]) {
                    tagged[tag] = {};
                }
                tagged[tag][choiceID] = acquiredObject
            } else {
                for (let i = 0; i < acquiredObject.tags.length; i++) {
                    tag = acquiredObject.tags[i];
                    if (!tagged[tag]) {
                        tagged[tag] = {};
                    }
                    tagged[tag][choiceID] = acquiredObject
                }
            }
        }
        console.log(JSON.parse(JSON.stringify(tagged)))
        console.log(JSON.parse(JSON.stringify(acquiredObjects)))
    }

    function normalizeAcquiredObjects(model, data) {
        let i, acquiredObject;
        const maxSortIndex = Number.MAX_SAFE_INTEGER;
        if (!data) {
            return null;
        }
        const acquiredObjects = {};
        if (model.is_single_item_model) {
            acquiredObject = !Array.isArray(data) ? data : data[0];
            if (!acquiredObject.id) {
                if (acquiredObject.product_code) {
                    acquiredObject.id = acquiredObject.product_code;
                } else {
                    acquiredObject.id = "single_item";
                }
            }
            acquiredObjects[acquiredObject.id] = acquiredObject;
        } else if (Array.isArray(data)) {
            let nextSortIndex = null;
            for (i = 0; i < data.length; i++) {
                acquiredObject = data[i];
                if (acquiredObject.hasOwnProperty('sort_index')) {
                    if (acquiredObject.sort_index <= maxSortIndex - data.length && (nextSortIndex === null || acquiredObject.sort_index >= nextSortIndex)) {
                        nextSortIndex = acquiredObject.sort_index + 1;
                    }
                }
            }
            nextSortIndex = nextSortIndex !== null ? nextSortIndex : 0;

            for (i = 0; i < data.length; i++) {
                acquiredObject = data[i];
                if (!acquiredObject.id) {
                    if (acquiredObject.product_code) {
                        acquiredObject.id = acquiredObject.product_code;
                    } else {
                        continue;
                    }
                }
                if (!acquiredObject.hasOwnProperty('sort_index')) {
                    acquiredObject.sort_index = nextSortIndex;
                    nextSortIndex++;
                }
                acquiredObjects[acquiredObject.id] = acquiredObject;
            }
        } else {
            for (let key in data) {
                if (key.charAt(0) === "_") {
                    continue;
                }
                acquiredObject = data[key];
                if (!acquiredObject.id) {
                    acquiredObject.id = key;
                }
                acquiredObjects[acquiredObject.id] = acquiredObject;
            }
        }
        for (let choiceID in acquiredObjects) {
            acquiredObject = acquiredObjects[choiceID];
            if (typeof acquiredObject !== 'object' || acquiredObject === null) {
                delete acquiredObjects[choiceID];
                continue;
            }
            if (!acquiredObject.hasOwnProperty('sort_index')) {
                acquiredObject.sort_index = maxSortIndex;
            }
        }

        return siteHelper.keyCount(acquiredObjects) > 0 ? acquiredObjects : null;
    }

    function onRequestComplete(acquiredObjects) {
        const model = this.root;

        const success = !!acquiredObjects;

        model.request_in_progress = false;
        if (success) {
            model.has_a_completed_request = true;
            model.last_request_did_fail = false;
            model.buildAcquiredChoices(acquiredObjects);
            for (let i = 0; i < model.requestCallbacks.length; i++) {
                model.requestCallbacks[i]();
            }
        } else {
            model.last_request_did_fail = true;
        }
        model.requestCallbacks = [];

        $rootScope.$broadcast("api_request_complete", {
            model_id: model.id,
            model_variation_id: model.model_variation_id,
            success: success
        });
    }


    function buildAcquiredChoices(acquiredObjects) {
        const model = this.root;

        const acquiredChoices = {};
        for (let choiceID in acquiredObjects) {
            const acquiredObject = acquiredObjects[choiceID];
            model.applyBasicObjectDetails(acquiredObject);
            if (model.isValidAcquiredObject && !model.isValidAcquiredObject(acquiredObject)) {
                continue;
            }
            const acquiredChoice = model.birthChoice(JSON.parse(JSON.stringify(acquiredObject)));
            model.applyAcquiredChoice(acquiredChoice);
            acquiredChoices[acquiredChoice.id] = acquiredChoice;
        }
        model.choices = acquiredChoices;
        applySorting(model);
        if (model.onItemsBuiltHandler) {
            model.onItemsBuiltHandler();
        }
    }

    function applyBasicObjectDetails(acquiredObject) {
        const model = this.root;

        acquiredObject.request_range_id = model.request_range_id ? model.request_range_id : acquiredObject.range;
        acquiredObject.request_api_code = model.api_code;
        acquiredObject.api_code = acquiredObject.product_code ? acquiredObject.product_code : model.api_code;
        acquiredObject.base_component_id = model.base_component_id;
        acquiredObject.parent_category_group_id = model.parent_category_group_id;
        acquiredObject.parent_category_group_type_id = model.parent_category_group_type_id;
        acquiredObject.parent_category_id = model.parent_category_id;

        acquiredObject.tags = acquiredObject.tags ? acquiredObject.tags : [];

        acquiredObject.colour_exceptions = acquiredObject.colour_exceptions ? siteHelper.arrayToObjectKeys(acquiredObject.colour_exceptions) : {};
        acquiredObject.style_exceptions = acquiredObject.style_exceptions ? siteHelper.arrayToObjectKeys(acquiredObject.style_exceptions) : {};
        if (acquiredObject.width === "M2M") {
            acquiredObject.width = "";
        }
        if (acquiredObject.height === "M2M") {
            acquiredObject.height = "";
        }
        if (acquiredObject.length === "M2M") {
            acquiredObject.length = "";
        }
        if (acquiredObject.depth === "M2M") {
            acquiredObject.depth = "";
        }

        acquiredObject.site_range_id = model.site_range_id;
        acquiredObject.model_id = model.id;
    }

    function applyAcquiredChoice(acquiredChoice) {
        const model = this.root;

        if (model.applyItemHandler) {
            model.applyItemHandler(acquiredChoice);
        }
        if (model.onItemAppliedHandler) {
            model.onItemAppliedHandler(acquiredChoice);
        }
    }

    function applySorting(model) {
        let i, j, k, choice;
        const choiceArray = [];
        for (let choiceID in model.choices) {
            choice = model.choices[choiceID];
            choiceArray.push(choice);
        }
        if (model.dataSortHandler) {
            model.dataSortHandler(choiceArray);
        } else {
            sortChoiceArray(choiceArray);
        }
        const choiceOrder = [];

        for (i = 0; i < choiceArray.length; i++) {
            choice = choiceArray[i];
            choiceOrder.push(choice.id);
        }
        model.choice_order = choiceOrder;
    }

    function sortChoiceArray(acquiredChoices) {
        acquiredChoices.sort(function (a, b) {
            if (a.sort_index < b.sort_index) {
                return -1;
            }
            if (a.sort_index > b.sort_index) {
                return 1;
            }
            const aName = a.name ? a.name.toUpperCase() : "";
            const bName = b.name ? b.name.toUpperCase() : "";
            if (aName < bName) {
                return -1;
            }
            if (aName > bName) {
                return 1;
            }
        })
    }

}]);